import React from "react";
import {
  IonAvatar,
  IonItem,
  IonLabel,
  IonList,
} from "@ionic/react";
import "../theme/AppStyles.css";


export const PayingUsers: React.FC<any> = (usersList) => {
  // console.log("Paying Users List:", usersList);

  // console.log("Jobs Summary in Admin Dashboard:", jobsSummary);
  // console.log("SchedulerDashboard");

  // const handleSchedulerClick = (e: any) => {
  //   const schedulerUID = e.currentTarget.getAttribute("data-scheduler-uid");
  //   const schedulerName = e.currentTarget.getAttribute("data-scheduler-name");
  //   const openJobs = e.currentTarget.getAttribute("data-scheduler-open-jobs");
  //   const filledJobs = e.currentTarget.getAttribute("data-scheduler-filled-jobs");
  //   const pastJobs = e.currentTarget.getAttribute("data-scheduler-past-jobs");

  //   // console.log("Clicked Scheduler UID:", schedulerUID);
  //   // console.log("Clicked Scheduler Name:", schedulerName);
  //   setSelectedSchedulerUID(schedulerUID);
  //   setSelectedSchedulerName(schedulerName);
  //   setSelectedOpenJobs(parseInt(openJobs));
  //   setSelectedFilledJobs(parseInt(filledJobs));
  //   setSelectedPastJobs(parseInt(pastJobs));

  //   // history.push(`/admin/scheduler/${schedulerUID}`);
  // };



  return (
    <React.Fragment>

    <IonList>
        {usersList.usersList
         
          .sort((a: { userScheduler: boolean; }, b: { userScheduler: boolean; }) => {
            if (!a.userScheduler && b.userScheduler) return -1;
            if (a.userScheduler && !b.userScheduler) return 1;
            return 0;
          })
          
          .map((user: {
              userUID: string;
              userName: string;
              userPICURL: string;
              userScheduler: boolean;

          
             
          }) => (
              <IonItem               
              >
                  <IonAvatar 
                    className="avatario"
                    slot="start"
                  >
                    <img src={user.userPICURL} alt="" />
                  </IonAvatar>
                  <IonLabel className="labelo">
                    <h2>
                      {user.userName}
                    </h2>
                  <p>User Type: {user.userScheduler ? "Scheduler" : "Regular User"}</p>

                <br></br>
              </IonLabel>
            </IonItem>
          ))}
      </IonList>    
  
    </React.Fragment>
  );
}
